// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"58ebd772","453":"15b3c4e5","667":"5ca18bd1"}[chunkId] + ".chunk.js";
};